export const TYPES = {
  AnimationManager: Symbol('AnimationManager'),
  CredentialsManager: Symbol('CredentialsManager'),
  ErrorManager: Symbol('ErrorManager'),
  KeyboardShortcutsManager: Symbol('KeyboardShortcutsManager'),
  PageManager: Symbol('PageManager'),
  PostMessageManager: Symbol('PostMessageManager'),
  ProjectManager: Symbol('ProjectManager'),
  RestrictionsManager: Symbol('RestrictionsManager'),
  SVGManager: Symbol('SVGManager'),
  VideoManager: Symbol('VideoManager'),
  ViewerLoader: Symbol('ViewerLoader'),
  VirtualizerService: Symbol('VirtualizerService'),
  WorkflowManager: Symbol('WorkflowManager'),
};
